import FormattedName from 'I18n/components/FormattedName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
const UserCheckbox = ({
  ownerId,
  selectedUsers,
  user,
  userPartOfSelectedTeams,
  handleUserChange,
  canAssignContent
}) => {
  const {
    firstName,
    lastName,
    email,
    id
  } = user;
  const ownerAsArray = Array.isArray(ownerId) ? ownerId : [ownerId];
  const isOwner = ownerAsArray.includes(id);
  const forceChecked = userPartOfSelectedTeams || isOwner;
  const tooltipMessage = isOwner ? 'salesContentPartitioning.assignmentPanel.tooltips.userIsOwner' : 'salesContentPartitioning.assignmentPanel.tooltips.userOnSelectedTeam';
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "left",
    disabled: !forceChecked,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: tooltipMessage
    }),
    children: /*#__PURE__*/_jsx(Checkbox, {
      checked: selectedUsers.includes(id) || forceChecked,
      readOnly: forceChecked || !canAssignContent,
      onChange: handleUserChange,
      value: id,
      children: /*#__PURE__*/_jsx(FormattedName, {
        givenName: firstName,
        familyName: lastName,
        email: email
      })
    }, `${id}-user-checkbox`)
  }, `${id}-checkbox-tooltip`);
};
export default UserCheckbox;